import { render, staticRenderFns } from "./ShopSetting.vue?vue&type=template&id=bfeca174&scoped=true&"
import script from "./ShopSetting.vue?vue&type=script&lang=js&"
export * from "./ShopSetting.vue?vue&type=script&lang=js&"
import style0 from "./ShopSetting.vue?vue&type=style&index=0&id=bfeca174&lang=scss&scoped=true&"
import style1 from "./ShopSetting.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfeca174",
  null
  
)

export default component.exports